export type DashboardChartView =
    | 'bar' | 'horizontalBar' | 'pie' | 'line'
    | 'area' | 'spline' | 'splineArea' | 'stackedBar' | 'comparisonBar' | 'serviceComparison' | 'fullPie' | 'polar';

export interface DashboardChartViewConfig {
    allowedViews: DashboardChartView[];
    recommendedView: DashboardChartView;
}

export const DASHBOARD_DISTRIBUTION_COLORS = [
    '#0D47A1', '#00897B', '#FFA726', '#AB47BC', '#EF5350',
    '#26A69A', '#5C6BC0', '#8BC34A', '#EC407A', '#607D8B',
];

export const getDashboardDistributionColor = (index: number) =>
    DASHBOARD_DISTRIBUTION_COLORS[index % DASHBOARD_DISTRIBUTION_COLORS.length];

export type ConfigurableChartDashboard =
    | 'gpa' | 'gradeLevel' | 'studentServices' | 'gender' | 'services' | 'match'
    | 'fafsa' | 'endReason' | 'participants' | 'eligibility'
    | 'race' | 'ethnicity' | 'iep' | 'lep' | 'schoolEnrollment' | 'enrollmentByAdvisor';

/**
 * Central capability map for chart cards. Add or remove a view here when a
 * dashboard should support a different set of visualizations.
 */
export const DASHBOARD_CHART_VIEW_CONFIG: Record<ConfigurableChartDashboard, DashboardChartViewConfig> = {
    gpa: {
        allowedViews: ['bar', 'comparisonBar', 'horizontalBar', 'pie', 'fullPie'],
        recommendedView: 'bar',
    },
    gradeLevel: {
        allowedViews: ['bar', 'comparisonBar', 'horizontalBar', 'pie', 'fullPie'],
        recommendedView: 'bar',
    },
    studentServices: {
        allowedViews: ['comparisonBar', 'serviceComparison', 'bar', 'horizontalBar', 'pie', 'fullPie'],
        recommendedView: 'comparisonBar',
    },
    gender: {
        allowedViews: ['bar', 'horizontalBar', 'pie', 'fullPie'],
        recommendedView: 'pie',
    },
    services: { allowedViews: ['bar', 'horizontalBar'], recommendedView: 'bar' },
    match: { allowedViews: ['pie', 'fullPie', 'bar', 'horizontalBar'], recommendedView: 'pie' },
    fafsa: { allowedViews: ['bar', 'horizontalBar', 'line', 'area', 'spline', 'splineArea'], recommendedView: 'bar' },
    endReason: { allowedViews: ['stackedBar', 'horizontalBar', 'line', 'area', 'spline', 'splineArea'], recommendedView: 'stackedBar' },
    participants: { allowedViews: ['pie', 'fullPie', 'bar', 'horizontalBar'], recommendedView: 'pie' },
    eligibility: { allowedViews: ['pie', 'fullPie', 'bar', 'horizontalBar'], recommendedView: 'pie' },
    race: { allowedViews: ['pie', 'fullPie', 'bar', 'horizontalBar'], recommendedView: 'pie' },
    ethnicity: { allowedViews: ['pie', 'fullPie', 'bar', 'horizontalBar'], recommendedView: 'pie' },
    iep: { allowedViews: ['pie', 'fullPie', 'bar', 'horizontalBar'], recommendedView: 'pie' },
    lep: { allowedViews: ['pie', 'fullPie', 'bar', 'horizontalBar'], recommendedView: 'pie' },
    schoolEnrollment: { allowedViews: ['horizontalBar', 'bar'], recommendedView: 'horizontalBar' },
    enrollmentByAdvisor: { allowedViews: ['horizontalBar', 'bar', 'pie', 'fullPie'], recommendedView: 'horizontalBar' },
};
